import React, { createContext, useState, useContext, ReactNode } from 'react';
import { IFileViewItem } from '../InsertBody/InsertBody';

// Context store for Insert Body's breadcrumb stack (folder path + the items
// of each visited folder). Mounted in index.tsx so the user's place in the
// template library survives switching tabs.

interface FileViewItemsContextType {
    fileViewItems: IFileViewItem[];
    setFileViewItems: React.Dispatch<React.SetStateAction<IFileViewItem[]>>;
}

const FileViewContext = createContext<FileViewItemsContextType | undefined>(undefined);

interface FileViewProviderProps {
    children: ReactNode;
}

export const FileViewProvider: React.FC<FileViewProviderProps> = ({ children }) => {
    const [fileViewItems, setFileViewItems] = useState<IFileViewItem[]>([]);

    return (
        <FileViewContext.Provider value={{ fileViewItems: fileViewItems, setFileViewItems: setFileViewItems }}>
            {children}
        </FileViewContext.Provider>
    );
};

export const useFileView = () => {
    const context = useContext(FileViewContext);
    if (!context) {
        throw new Error('useFileView must be used within a FileViewProvider');
    }
    return context;
};